// 9fbef606107a605d69c0edbcd8029e5d

// PDP Inventory API constants
const MAX_PRODUCT_PART_NUMBER_ALLOWED = 24;

// ESG Badge maximum count constant
export const MAX_NO_OF_ESG_BADGES_TO_BE_DISPLAYED = 4;

export default MAX_PRODUCT_PART_NUMBER_ALLOWED;
